/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".img-margin[_ngcontent-%COMP%]{margin:0}[padding-bottom-15][_ngcontent-%COMP%]{padding-bottom:15px}[color-orange][_ngcontent-%COMP%]{color:orange}[color-grey][_ngcontent-%COMP%]{color:#717171}"];
export { styles as styles };
